import apiService from '@/services/apiService';

const state = {
  experts: [],
  expertiseAreas: [],
  industries: [],
  ageGroups: [],
  regions: [],
  backgrounds: [],
  loading: false,
  error: null
};

const getters = {
  experts: state => state.experts,
  expertiseAreas: state => state.expertiseAreas,
  industries: state => state.industries,
  ageGroups: state => state.ageGroups,
  regions: state => state.regions,
  backgrounds: state => state.backgrounds,
  isLoading: state => state.loading,
  error: state => state.error
};

const actions = {
  async fetchExperts({ commit, state }, filters = {}) {
    // Skip fetching if no filters are provided and experts are already loaded
    if (Object.keys(filters).length === 0 && Array.isArray(state.experts) && state.experts.length > 0) {
      return state.experts;
    }
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      // Ensure we fetch a large page_size by default to load all experts in one request (client-side pagination)
      const params = { page_size: 1000, ...filters };
      const response = await apiService.get('/experts/list/', { params });
      const list = Array.isArray(response.data) ? response.data : (response.data?.results || []);
      commit('SET_EXPERTS', list);
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to fetch experts');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async fetchExpertiseAreas({ commit }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await apiService.get('/experts/expertise-areas/');
      commit('SET_EXPERTISE_AREAS', response.data);
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to fetch expertise areas');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async fetchIndustries({ commit }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await apiService.get('/experts/industries/');
      commit('SET_INDUSTRIES', response.data);
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to fetch industries');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async fetchAgeGroups({ commit }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await apiService.get('/experts/age-groups/');
      commit('SET_AGE_GROUPS', response.data);
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to fetch age groups');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async fetchRegions({ commit }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await apiService.get('/experts/regions/');
      commit('SET_REGIONS', response.data);
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to fetch regions');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async fetchBackgrounds({ commit }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await apiService.get('/experts/backgrounds/');
      commit('SET_BACKGROUNDS', response.data);
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to fetch backgrounds');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

const mutations = {
  SET_EXPERTS(state, experts) {
    state.experts = Array.isArray(experts) ? experts : [];
  },
  SET_EXPERTISE_AREAS(state, list) {
    state.expertiseAreas = list;
  },
  SET_INDUSTRIES(state, list) {
    state.industries = list;
  },
  SET_AGE_GROUPS(state, list) {
    state.ageGroups = list;
  },
  SET_REGIONS(state, list) {
    state.regions = list;
  },
  SET_BACKGROUNDS(state, list) {
    state.backgrounds = list;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}; 